import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import useSiteConfig from 'hooks/useSiteConfig';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const siteConfig = useSiteConfig();
  const infoFooterBlock = siteConfig?.InfoFooterBlock;

  return (
    <footer className={classNames(className, 'footer')}>
      <Row className="g-1 justify-content-between align-items-center h-100">
        <Col xs={12} sm="auto" className="text-center">
          {infoFooterBlock ? (
            <div
              className="mb-0 mt-2 mt-sm-0 text-900"
              dangerouslySetInnerHTML={{ __html: infoFooterBlock }}
            />
          ) : (
            <p className="mb-0 mt-2 mt-sm-0 text-900">
              Thank you for using{' '}
              {siteConfig?.Title || process.env.REACT_APP_TITLE}
              <span className="d-none d-sm-inline-block" />
              <span className="d-none d-sm-inline-block mx-1">|</span>
              <br className="d-sm-none" />
              {new Date().getFullYear()} &copy;{' '}
              <a href="/" target="_blank" rel="noreferrer">
                {siteConfig?.Title || process.env.REACT_APP_TITLE}
              </a>
            </p>
          )}
        </Col>
        <Col xs={12} sm="auto" className="text-center">
          <p className="mb-0 text-600">v{process.env.REACT_APP_VERSION}</p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
